module.exports = __webpack_public_path__ + "img/game.e9780641.png";